/**
 * Public paths
 */
export enum PublicRoutes {
  Terms = '/terms',
  Privacy = '/privacy',
  DoNotSell = '/do-not-sell',
  Help = '/help',
  Claim = '/claim/:shortCode',
  ReserveParking = '/reserve-parking',
  ParkNowV2 = '/park-now-v2',
}

export const publicPaths = Object.values(PublicRoutes);

/**
 * Protected (Must be logged in aka 'authorized') paths
 */
export enum ProtectedRoutes {
  ForwardSlash = '/',
  VisitPage = '/visit',
  PaymentPage = '/payment',
  ProfilePage = '/profile',
  AccountDeletePage = '/profile/terms-and-privacy',
  MembershipPage = '/membership',
  RedeemPage = '/redeem',
  VehiclePage = '/vehicle',
  VisitReceiptPage = '/visit/:visitUuid',
  DashboardPage = '/dashboard',
  ActivityPage = '/activity',
  ConfirmMissedEntryPage = '/confirm-entry',
  PromotionsPage = '/promo',
  RewardsPage = '/rewards',
  LinkAccountPage = '/rewards/link-account',
  ReceiptPage = '/receipt/:invoiceUuid',
  ParkNowPage = '/park-now',
  ConfirmSubscription = '/confirm-subscription',
  SubscriptionConfirmed = '/subscription-confirmed',
  ReserveParkingConfirmationPage = '/reserve-parking-confirmation',
}

export const protectedPaths = Object.values(ProtectedRoutes);

/**
 * DefaultOnboardingRoutes is the default sign up flow when no onboarding tasks are required
 */
export enum DefaultOnboardingRoutes {
  SignIn = '/sign-in',
  Verify = '/verify',
  SignUp = '/sign-up',
  Vehicle = '/sign-up/add-vehicle',
  PaymentMethod = '/sign-up/add-payment',
}

export const defaultOnboardingPaths = Object.values(DefaultOnboardingRoutes);

/**
 * ReferralOnboardingRoutes are the routes used for onboarding members who have been referred from an external source
 */
export enum ReferralOnboardingRoutes {
  FinishAccount = '/finish-account',
}

export const referralOnboardingPaths = Object.values(ReferralOnboardingRoutes);

/**
 * StartParkingOnboardingRoutes are used when the backend sends us onboarding tasks (todos)
 */
export enum StartParkingOnboardingRoutes {
  Onboard = '/onboard',
  SelectVisitDuration = '/select-visit-duration',
  SignIn = '/auth/sign-in',
  Verification = '/auth/verify',
  AddVehicle = '/onboard/add-vehicle',
  AddEmail = '/onboard/add-email',
  SelectVehicle = '/onboard/select-vehicle',
  PaymentMethod = '/onboard/add-payment',
}

export const startParkingOnboardingPaths = Object.values(StartParkingOnboardingRoutes);

/**
 * ExpressOnboardingRoutes are the step-level routes for the new express onboarding flow (feature-flagged)
 */
export enum ExpressOnboardingRoutes {
  Landing = '/onboard',
  VerifyPhone = '/onboard/verify-phone',
  AddVehicle = '/onboard/add-vehicle',
  AddPayment = '/onboard/add-payment',
  AddEmail = '/onboard/add-email',
  ConfirmEntry = '/onboard/confirm-entry',
  Success = '/onboard/success',
}

export const expressOnboardingPaths = Object.values(ExpressOnboardingRoutes);

/**
 * /tasks is only used for the required Payment Due TODO item (user has to pay for unpaid visit)
 */

export enum TaskItemRoutes {
  Tasks = '/tasks',
}

export const taskItemPaths = Object.values(TaskItemRoutes);

export const authPaths = [...publicPaths, ...protectedPaths];
